import { trackEvent, eventTypeConstants, eventNameConstants } from 'dibs-tracking';

const CATEGORY = 'navigation';
const ACTION = 'footer navigation click';

export const trackCheckoutFooterNavigationClick = ({ label }: { label: string }): void => {
    trackEvent({
        category: CATEGORY,
        action: ACTION,
        label,
        isInteractiveEvent: true,
        event: eventTypeConstants.EVENT_EVENT,
        eventName: eventNameConstants.EVENT_NAVIGATION,
        step_interaction_name: ACTION,
        interaction_type: label,
    });
};
